import React from 'react';
import PropTypes from 'prop-types';
import { round } from 'core/utils';

import { Background, Foreground } from './lineStyles.js';

const calculatePercentage = num => {
	const value = round(num * 100);
	return `${value}%`;
};

const Line = ({ percentage }) => (
	<Background>
		<Foreground width={calculatePercentage(percentage)} />
	</Background>
);

Line.propTypes = {
	percentage: PropTypes.number.isRequired
};

export default Line;
